import type { Severity } from '@prerender/diagnostics-api';

import { bandRangeLabel, floorLabel, type RateRules } from './originBlockingFigures';
import { severityLabel } from './severityLabels';
import { severityToneClass } from './SeverityTag';

type SeverityBandsProps = {
  rules: RateRules;
  severity: Severity;
  rate: string;
};

function SeverityBands({ rules, severity, rate }: SeverityBandsProps) {
  return (
    <div className="diagnostics-severity-bands">
      <span className="diagnostics-severity-bands-lead">How severity is set (blocked request rate):</span>
      <ul className="diagnostics-severity-bands-list" aria-label="Severity bands">
        {rules.bands.map((band) => {
          const marked = band.severity === severity;

          return (
            <li
              key={band.severity}
              className={
                marked
                  ? `diagnostics-severity-band diagnostics-severity-band-marked ${severityToneClass(band.severity)}`
                  : 'diagnostics-severity-band'
              }
              aria-current={marked || undefined}
            >
              <span>
                <strong>{severityLabel(band.severity)}</strong> {bandRangeLabel(band)}
              </span>
              {marked && <span className="diagnostics-severity-band-marker">▲ this incident: {rate}</span>}
            </li>
          );
        })}
      </ul>
      <span className="diagnostics-severity-bands-floor">{floorLabel(rules.floorShare)}</span>
    </div>
  );
}

export default SeverityBands;
